import * as React from "react";

const SvgComponent = ({ bgcolor, border, color }) => (
  <svg width={30} height={30} viewBox="0 0 30 30" fill="none">
    <rect
      x={1.102}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      fill={bgcolor}
      stroke={border}
    />
    <path
      d="M15.601 7.059c-3.76 0-6.818 3.363-6.818 7.5 0 4.136 3.058 7.5 6.818 7.5 3.761 0 6.819-3.364 6.819-7.5 0-4.137-3.058-7.5-6.819-7.5Zm-5.31 7.5c0-1.31.401-2.527 1.062-3.506l7.435 8.18a4.947 4.947 0 0 1-3.187 1.168c-2.928 0-5.31-2.621-5.31-5.842Zm9.56 3.505-7.436-8.18A4.947 4.947 0 0 1 15.6 8.718c2.929 0 5.311 2.62 5.311 5.842 0 1.31-.387 2.526-1.062 3.505Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
